import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "frame"]
  static values = {
    url: String
  }

  connect() {
    // Initialize the controller
    console.log("DonationType controller connected")
  }

  switch(event) {
    event.preventDefault()
    const link = event.currentTarget
    const url = link.getAttribute("href")
    
    // Update active state
    this.linkTargets.forEach(target => {
      target.closest(".tabs__item").classList.remove("active")
    })
    link.closest(".tabs__item").classList.add("active")

    // Use Turbo to fetch and update the frame
    Turbo.visit(url, { frame: "donation-type-frame" })
  }
} 